<template>
  <v-app v-if="isLoggedIn">
    <router-view class="mb-10" />
    <v-footer app class="overline">
      harvester {{ this.$appVersion }} <v-spacer />lakesoft
    </v-footer>
  </v-app>
  <v-app v-else>
    <v-container fluid fill-height>
      <transition mode="out-in">
        <router-view />
      </transition>
    </v-container>
  </v-app>
</template>

<script>
import evernote from '@/services/EvernoteService'
import settings from '@/services/SettingsService'
import indexedDB from '@/services/IndexedDBService'

export default {
  data() {
    return {
      isLoggedIn: false
    }
  },
  async created() {
    // console.log(evernote.sessionId)
    // await indexedDB.setup()
    this.isLoggedIn = evernote.isLoggedIn
    this.$router.beforeResolve(async (to, from, next) => {
      this.isLoggedIn = evernote.isLoggedIn // 必要
      if (to.matched.some(record => record.meta.requiresLoggedIn)) {
        if (!evernote.isLoggedIn || !evernote.loggedInBefore) {
          next({ path: '/login' })
        }
        indexedDB.setup().then(() => {
          // console.log(data)
          evernote.setup() // Notesから移動＆await→ 画面表示に必要
        })
        // await evernote.setup() // タイミングによっては IndexedDBの初期化が遅れる為2回よぶ
        // → 先頭で明示的に indexedDB.setup() を呼ぶので不要
        this.$vuetify.theme.dark = settings.darkmode
      }
      next()
    })
  }
}
</script>

<style lang="scss">
// https://dev83.com/vue-spa-transition/#Appvue
// 01/14 なぜか効かない...
.v-enter {
  transform: translate(-100px, 0);
  opacity: 0;
}
.v-enter-to {
  opacity: 1;
}
.v-enter-active {
  transition: all 1s 0s ease;
}
.v-leave {
  transform: translate(0, 0);
  opacity: 1;
}
.v-leave-to {
  transform: translate(100px, 0);
  opacity: 0;
}
.v-leave-active {
  transition: all 0.5s 0s ease;
}
</style>
